import React, { useState, useEffect } from 'react';
import {
  PaperProps,
  dateFormatYMD,
  bookSessionSuccess,
  cancelSessionSuccess,
} from 'constants';
import * as yup from 'yup';
import {
  onSave,
  refinePayload,
  useNotification,
  fieldValidation,
  getDialogHeading,
} from 'utils/commonUtils';
import { format } from 'date-fns';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
  postTutoringV2Session,
  putCancelTutoringV2Session,
} from './services/bookNewSessionTabV2Api';
import { yupResolver } from '@hookform/resolvers/yup';
import DialogContent from '@mui/material/DialogContent';
import { ConfirmSubmitButton } from './bookNewSessionTabUtils';
import { FormInputText } from 'components/Common/Forms/FormTextField';

const bookSessionDialogSchema = yup.object().shape({
  reasonForBookOrCancel: fieldValidation(4000),
});

const BookTutoringSessionV2Dialog = ({
  slot,
  open,
  student,
  isBooked,
  subjectId,
  sessionId,
  loadAllData,
  selectedDate,
  overrideLimits,
  handleDialogClose,
}) => {
  const dispatch = useDispatch();
  const { setOpenNotification, setNotificationMessage, NotificationPopup } =
    useNotification();

  const [loadingButton, setLoadingButton] = useState(false);

  const defaultValue = {
    reasonForBookOrCancel: '',
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(bookSessionDialogSchema),
  });

  const { handleSubmit, control, reset, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.reasonForBookOrCancel]);

  const handleClose = () => {
    handleDialogClose();
    reset(defaultValue);
  };

  const onSubmit = async (data) => {
    const payload = {
      date: format(new Date(selectedDate), dateFormatYMD),
      overrideLimits: overrideLimits,
      reason: data?.reasonForBookOrCancel,
      studentId: student?.studentId,
      subjectId: subjectId,
      timeSlotId: slot?.timeSlotId,
    };

    const cancelSessionPayload = {
      statusNote: data?.reasonForBookOrCancel,
    };

    onSave(
      isBooked ? cancelSessionSuccess : bookSessionSuccess,
      !isBooked,
      postTutoringV2Session,
      putCancelTutoringV2Session,
      !isBooked ? refinePayload(payload) : refinePayload(cancelSessionPayload),
      isBooked ? sessionId : slot?.timeSlotId,
      loadAllData,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton,
      loadingButton,
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={PaperProps}>
        {getDialogHeading(
          isBooked ? 'Cancel Session' : 'Book Session',
          handleClose,
        )}
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormInputText
                name="reasonForBookOrCancel"
                type="text"
                control={control}
                label={isBooked ? 'Cancel Reason' : 'Reason for Tutoring'}
                helperText={errors?.reasonForBookOrCancel?.message}
                errors={!!errors.reasonForBookOrCancel}
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={12} justifyItems="right">
              <ConfirmSubmitButton
                onSubmit={onSubmit}
                isBooked={isBooked}
                loading={loadingButton}
                handleSubmit={handleSubmit}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default BookTutoringSessionV2Dialog;
